import React from "react";

/**
 * Visual indicator showing where the agent's pointer is on the customer's
 * page. Driven entirely by props — the executor updates `position` on every
 * mousemove. `pointer-events: none` so it never blocks the customer from
 * doing their own clicks.
 */
export function RemoteCursor({ position }) {
  if (!position) return null;
  const x = (position.x || 0) * window.innerWidth;
  const y = (position.y || 0) * window.innerHeight;
  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        transform: `translate(${x}px, ${y}px)`,
        zIndex: 2147483645,
        pointerEvents: "none",
        transition: "transform 60ms linear",
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        style={{ filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.45))" }}
      >
        <path
          d="M3 2 L21 11 L13 13 L11 21 Z"
          fill="#f59e0b"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
      <span
        style={{
          position: "absolute",
          left: 22,
          top: 18,
          background: "#f59e0b",
          color: "white",
          fontSize: 10,
          fontWeight: 600,
          padding: "1px 6px",
          borderRadius: 4,
          whiteSpace: "nowrap",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        Agent
      </span>
    </div>
  );
}
